import { AnimatePresence, motion } from "framer-motion";
import { useFeed, feeds } from "./hooks";
import { GOLD } from "./data";

function Feed({ title, items, render, testid, accent, h }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#0a0a0a]/80 backdrop-blur-md p-4 overflow-hidden" style={{ height: h }} data-testid={testid}>
      <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] text-white/50 mb-3">
        <span className="h-1.5 w-1.5 rounded-full animate-pulse" style={{ background: accent }} />{title}
      </div>
      <div className="space-y-2">
        <AnimatePresence initial={false} mode="popLayout">
          {items.map((it) => (
            <motion.div key={it.id} layout initial={{ opacity: 0, x: -24 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.35 }}
              className="rounded-lg border border-white/5 bg-white/[0.03] px-3 py-2 text-xs font-mono">{render(it)}</motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}

export function Feeds({ compact = false }) {
  const launches = useFeed(feeds.launch, 900, compact ? 4 : 7);
  const posts = useFeed(feeds.post, 1300, compact ? 4 : 7);
  const h = compact ? 220 : 340;
  return (
    <div className={compact ? "grid grid-cols-2 gap-3" : "grid gap-4"}>
      <Feed title="PUMP.FUN · NEW LAUNCHES" testid="engine-feed-pump" accent="#4ade80" h={h} items={launches}
        render={(l) => <div className="flex justify-between"><span className="text-white/80">${l.sym}</span><span className="text-white/40">{l.age}s · ${l.mcap}k</span></div>} />
      <Feed title="X · CALLERS + KOLS" testid="engine-feed-x" accent="#38bdf8" h={h} items={posts}
        render={(p) => <div className="truncate"><span style={{ color: GOLD }}>{p.who}</span> <span className="text-white/60">{p.text}</span></div>} />
    </div>
  );
}
